(function(angular) {
    'use strict';

    angular.module('bmrcReportEditOptions',
        ['bento.modern', 'bm.reporting.components.templates', 'bmpFilterTreeComponent', 'bmpDateRangeBoxes',
            'bmpGroupSort', 'bmpDetailVmFactory', 'bmrcReportGenerateModalService', 'bmrcReportListService', 'bmpAdditionalCustomOptions', 'bmpGroupSortItem'])
        .component('bmrcReportEditOptions', {
        restrict: 'E',
        templateUrl: 'src/reporting/edit/report-edit-options.html',
        bindings: {
            /**
             * Expected to have the following properties
             * reportId: string
             * reportName: string
             *
             * Expected to have the following callback functions:
             * @callback: loadReportOptionsScreenData: Loads the data required to
             * populate the various areas of the report options screen. Returns
             * a promise with the report options setup json.
             * @callback: loadReportOptions: Loads the previously saved set
             * of options.
             * @callback: loadDefaultReportOptions: Loads the default report option
             * to use in instances where no options can be loaded
             */
            reportController: '='
        },
        controllerAs: 'vm',
        controller: ['$q', '$scope', 'bmpDetailVmFactory', 'bmrcReportGenerateModalService', 'bmrcReportListService', '$element',
            function ($q, $scope, detailVmFactory, reportGenerateModalService, reportListService, $element) {
                this.$onInit = function () {
                    var vm = this;
                    vm.loading = true;
                    Object.defineProperty(vm, 'selectedDateRange', {
                        get: function () {
                            if (vm.reportData && vm.reportData.dateRange && vm.screenData) {
                                return vm.screenData.$dateRangeOptions[vm.reportData.dateRange.reportDateRangeId];
                            }
                            return undefined;
                        }
                    });

                    /**
                     * Overwrites the existing start and end dates if it was calculated (not editable)
                     * from the backend, because they may be stale.
                     */
                    vm.initializeReportData = function () {
                        if (vm.screenData && vm.reportData) {
                            var selectedDateRange = vm.selectedDateRange;
                            if (selectedDateRange && !selectedDateRange.editable) {
                                vm.reportData.dateRange.startDate = selectedDateRange.startDate;
                                vm.reportData.dateRange.endDate = selectedDateRange.endDate;
                            }
                            // Map the options for the bmp-group-sort component
                            if (vm.screenData.detailByItems) {
                                vm.screenData.detailByItems.forEach(function (item) {
                                    item.properties = item.sortByItems;
                                });
                            }
                            if (vm.screenData.groupByItems) {
                                vm.screenData.groupByItems.forEach(function (item) {
                                    item.properties = item.sortByItems;
                                });
                            }
                            if (vm.screenData.groupDetailByItems) {
                                vm.screenData.groupDetailByItems.forEach(function (item) {
                                    item.properties = item.sortByItems;
                                });
                            }
                            if (vm.screenData.groupByItemsRequired) {
                                vm.screenData.groupByItemsRequired.forEach(function (item) {
                                    item.properties = item.sortByItems;
                                });
                            }

                            // Initialize the required group/detail by, if it was not provided by the backend.
                            if (!vm.reportData.detailBy) {
                                    vm.reportData.detailBy = { order: 'ASCENDING' };
                            }
                            if (vm.screenData.groupByItemsRequired && vm.screenData.groupByItemsRequired.length > 0) {
                                if (!vm.reportData.groupByRequired) {
                                    vm.reportData.groupByRequired = { order: 'ASCENDING' };
                                }
                            }

                            if (vm.reportController.afterInitializeData) {
                                vm.reportController.afterInitializeData(vm.screenData, vm.reportData);
                            }
                        }
                    };

                    var loadData = function () {
                        /**************************************************************
                        * Load the report option setup data from the passed
                        * controller. Returns a promise with the loaded data.
                        */
                        var screenDataPromise = vm.reportController.loadReportOptionsScreenData().then(function (screenData) {
                            // Cache the dateRangeOptions in a map so we can easily look them up by id
                            screenData.$dateRangeOptions = {};
                            if (screenData.dateRangeOptions) {
                                screenData.dateRangeOptions.forEach(function (element) {
                                    screenData.$dateRangeOptions[element.id] = element;
                                });
                            }
                            vm.screenData = screenData;
                            vm.initializeReportData();
                            return screenData;
                        });

                        /**************************************************************
                         * Load the previously stored options.
                         */
                        var reportDataPromise = vm.reportController.loadReportOptions(screenDataPromise).then(function (reportData) {
                            if (reportData) {
                                vm.reportData = reportData;
                            }
                            vm.initializeReportData();
                            vm.setLabelsToComboboxes();
                        });
                        return $q.all([screenDataPromise, reportDataPromise]);// TODO - ng161 - handle reject on $q.all, or with the pieces
                    };
                    var detailArgs = {
                        formName: 'reportOptionsForm',
                        id: vm.reportController.reportId,
                        loadDataPromise: loadData,
                        savePromise: function () { return vm.reportController.saveReportOptions(vm.reportData, vm.screenData); },
                        canSave: function () { return true; },
                        //navigatingAwayCanSave: () => this.navigatingAwayCanSave(),
                        backLink: vm.reportController.backLinkUrl,
                    };

                    vm.detail = detailVmFactory.create(detailArgs, $scope);
                    vm.detail.loadData();

                    /**************************************************************
                     * Save the options and generate the report.
                     */
                    vm.saveAndGenerate = function () {
                        vm.detail.save(false).then(function () {// TODO - ng161 - handle reject from save? Or should this happen in detailVM?
                            reportListService.setSecuredReportDownloadUrl(function (filter, item) { return vm.reportController.getSecuredReportDownloadUrl(filter, item); });// TODO - ng161 - handle reject from getSecuredReportDownloadUrl
                            reportListService.setSendReportToOnvioDocumentsUrl(function (filter, item) { return vm.reportController.getSendReportToOnvioDocumentsUrl(filter, item); });// TODO - ng161 - handle reject from getSendReportToOnvioDocumentsUrl
                            reportListService.setGetSelectedFolder(function () { return vm.reportController.getSelectedFolder(); });// TODO - ng161 - handle reject from getSelectedFolder
                            reportListService.setUseNewAsyncMode( function () { return ('useNewAsyncMode' in vm.reportController ? vm.reportController.useNewAsyncMode() : false); });
                            if ('useNewAsyncMode' in vm.reportController ? vm.reportController.useNewAsyncMode() : false) {
                                reportListService.setProcessCreateDocumentRequestToSocketSrv(function (jobId, isSubscribe) { return vm.reportController.processCreateDocumentRequestToSocketSrv(jobId, isSubscribe); });
                                reportListService.setCreateDocumentRequestUrl(function () { return vm.reportController.getCreateDocumentRequestUrl(); });
                                reportListService.setSocketServicePromise(function () { return vm.reportController.getSocketServicePromise(); });
                                reportListService.setCreateDocumentApipromise(function () { return vm.reportController.getCreateDocumentApipromise(); });
                                reportListService.setCloseSocketConnection(function () { return vm.reportController.closeSocketConnection(); });
                                reportListService.setInsertIntoSocketSrvTracing(function (jobId, payload) { return vm.reportController.insertIntoSocketSrvTracing(jobId, payload); });
                            }
                            if (vm !== undefined && vm.screenData !== undefined && vm.screenData.reportDefinition !== undefined) {
                                reportGenerateModalService.showDialog([{ id: vm.reportController.reportId, systemId: vm.screenData.reportDefinition.code }], reportListService);
                            } else {
                                reportGenerateModalService.showDialog([{ id: vm.reportController.reportId }], reportListService);
                            }
                        });
                    };

                    /**************************************************************
                     * Save the options and close the options screen.
                     */
                    vm.saveAndClose = function () {
                        vm.detail.save();
                    };

                    /**************************************************************
                     * -Event Method-
                     * Set selected dates
                     */
                    vm.onDateOptionChange = function (item) {
                        if (item) {
                            if (!vm.reportData.dateRange) {
                                vm.reportData.dateRange = {};
                            }
                            vm.reportData.dateRange.reportDateRangeId = item.id;
                            vm.reportData.dateRange.startDate = item.startDate;
                            vm.reportData.dateRange.endDate = item.endDate;
                        }
                    };

                    /**************************************************************
                     * The binding mappings for the bmp-group-sort component
                     */
                    vm.groupingBindings = { path: 'groupByPath', property: 'path', order: 'order' };

                    vm.setLabelsToComboboxes = function() {
                        const enumComboNodeList = $element[0].querySelectorAll('bmp-enum-combo');
                        const enumCombos = Array.from(enumComboNodeList);
                        if (enumCombos.length) {
                            // set combobox's aria-label to bmpEnumCombo's placeholder
                            const enumCombosWithPlaceholder = enumCombos.filter(cb => cb.getAttribute('placeholder'));
                            enumCombosWithPlaceholder.forEach(enumCombo => {
                                const placeholder = enumCombo.getAttribute('placeholder');
                                const combobox = enumCombo.querySelector('[role="combobox"]');
                                if (combobox) {
                                    combobox.setAttribute('aria-label', placeholder);
                                }
                            });
                        }
                    };
                };
            }]
    });

})(window.angular);
